
import request from '@/utils/request';

// 问题列表 type
export function getBackdropsList(options) {
  return request({
    url: '/operate/backdrops/page-list',
    method: 'get',
    params: options
  });
}
// 学校
export function getBackdropsSchool(options) {
  return request({
    url: '/op/school/all',
    method: 'get',
    params: options
  });
}
// 添加
export function getBackdropsAdd(options) {
  return request({
    url: '/operate/backdrops/',
    method: 'post',

    data: options
  });
}
// 编辑
export function getBackdropsEdit(options, id) {
  return request({
    url: `/operate/backdrops/${id}`,
    method: 'post',
    data: options
  });
}
// 状态
export function getBackdropsEditStatus(options) {
  return request({
    url: '/operate/backdrops/update-status',
    method: 'post',
    data: options
  });
}
// 查看
export function getBackdropsView(options) {
  return request({
    url: '/operate/backdrops/' + options.id,
    method: 'get'
  });
}
